/**
 * 固件升级宿主钩子：用 rapoo-element Dialog 承接 WebHID 进 Boot / 授权。
 * 仅在真正发起升级时 ensure 一次（useFirmwareUpgrade / sdk-test），不要在 main 全局注册。
 * 后续升级相关弹窗可继续挂在此 hooks 上扩展。
 */
import { createApp, type App } from 'vue'
import {
  FIRMWARE_AUTH_CANCELLED,
  getFirmwareHostHooks,
  setFirmwareHostHooks,
  type FirmwareAuthPromptRequest,
  type FirmwareHostHooks,
} from '@rapoo/device-sdk'
import i18n from '@/locales'
import FirmwareAuthDialog from '@/components/firmware/FirmwareAuthDialog.vue'

function requestFirmwareAuth(request: FirmwareAuthPromptRequest): Promise<void> {
  return new Promise((resolve, reject) => {
    const container = document.createElement('div')
    document.body.appendChild(container)

    let app: App<Element> | null = null
    const cleanup = () => {
      app?.unmount()
      app = null
      container.remove()
    }

    app = createApp(FirmwareAuthDialog, {
      request,
      onConfirm: () => {
        cleanup()
        resolve()
      },
      onCancel: () => {
        cleanup()
        const error = new Error(FIRMWARE_AUTH_CANCELLED)
        error.name = FIRMWARE_AUTH_CANCELLED
        reject(error)
      },
    })
    app.use(i18n)
    app.mount(container)
  })
}

const hooks: FirmwareHostHooks = {
  requestFirmwareAuth,
  // 未来可在此扩展其它升级弹窗能力
}

/** 幂等：升级流程入口调用；已注册则跳过 */
export function ensureFirmwareHostHooks(): void {
  if (getFirmwareHostHooks()) return
  setFirmwareHostHooks(hooks)
}
